var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.46,
    height: 25,
    viewBox: "0 0 16.46 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DistributorsDark",
    transform: "translate(-91.419 -528.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7472",
    "data-name": "Group 7472",
    transform: "translate(91.419 528.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7328",
    "data-name": "Path 7328",
    d: "M555.861,77.053a8.282,8.282,0,0,0-8.23,8.333,8.38,8.38,0,0,0,.919,3.83l.158.294.032.056,7.121,12.488,7.121-12.488.032-.056.158-.294a8.381,8.381,0,0,0,.919-3.83A8.282,8.282,0,0,0,555.861,77.053Zm0,10.715A2.966,2.966,0,1,1,558.79,84.8,2.948,2.948,0,0,1,555.861,87.768Z",
    transform: "translate(-547.631 -77.053)",
    fill: "#3c3c3b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.a459967f96467a9834a2d719a30fe84f.svg";
export { ForwardRef as ReactComponent };